<div class="container navtop">

    <h2 class="col-12 primary-font"><b>Je recharge mon véhicule</b></h2>

  

     <div class="row justify-content-center mb-5">
        <mat-card  *ngIf="stationDetail" class="col-11 col-lg-6 bordure mat-elevation-z8">
            <mat-card-content>

                 <!-- <mat-progress-bar class="row " *ngIf="loading" mode="indeterminate"></mat-progress-bar>  -->
                <h3 class="text-center"><b>Détails de la station</b></h3>

                <h4 class="col-12"><b>{{stationDetail?.name}}</b></h4>



                <h4 class="col-12">{{stationDetail?.street}}, {{stationDetail?.zipcode}}
                    {{stationDetail?.city}}</h4>

                <h4 class="col-12">{{stationDetail?.price.description_price}}</h4>


                <!-- nom prenom -->
                <div class="row justify-content-center">

                    <img mat-card-image class="col-6" style="margin-bottom: 0px !important;"
                        [src]="sanitizeImageUrl('data:'+stationDetail?.image.mimetype+';base64,'+stationDetail?.image.file)"
                        alt="clem">


                </div>


            </mat-card-content>
        </mat-card>



    </div> 



  <div  *ngIf="stationDetail">

    <form [formGroup]="formGroup">

        <div class="row justify-content-center">
            <mat-card class="col-11 col-lg-6 bordure mat-elevation-z8">
                <mat-card-content>

                    <h2 class="text-center primary-font"><b>Carte bancaire</b></h2>
                    <h5 style="color:red" class="text-center">Attention nouvelle procédure 3DSecure. En fin de procédure 3D
                        secure de votre banque,
                        ne refermez pas la fenêtre mais cliquez sur le bouton « Retour site/retour boutique/suivant »
                    </h5>


                    <div class="row  justify-content-center my-1">
                        <div class="col-10 col-md-7">
                            <img class="img-fluid" [src]="getImage()">

                        </div>
                    </div>

                    <h5 style="color:red" class="text-center mt-1">Veuillez toujours vérifier que vous êtes sur la bonne adresse
                    </h5>

                    <div class="row justify-content-center mt-4">
                        <mat-card class="col-5 col-md-3" style="padding: 0px !important; height: 40px">
                            <mat-card-content>
                                <div class="row justify-content-center">
                                    <mat-icon  style="margin-top: 10px;font-size: 22px !important" mat-list-icon>lock</mat-icon>
                                    <h3  style="margin-top: 6px" mat-line>clem.mobi</h3>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
        


                    <!-- card-number -->
                    <div class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <input  matInput [textMask]="numberMask" type="tel" placeholder="Numéro de carte :"
                                formControlName="numberCard">
                            <mat-error
                                *ngIf="!formGroup.controls['numberCard'].valid || formGroup.controls['numberCard'].touched">
                                {{ getErrorNumberCard() }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                      <!--  Type:   -->
                           <div  *ngIf="isCarteType === true" class="row justify-content-center">
                            <mat-form-field class="col-10">
                                <mat-label>Type :</mat-label>
                                <mat-select class="" formControlName="carteType">
                                    <mat-option class="" *ngFor="let type of carteList"
                                        [value]="type">{{type}}</mat-option>
                                </mat-select>

                                <mat-error
                                *ngIf="!formGroup.controls['carteType'].valid || formGroup.controls['carteType'].touched">
                                {{ getErrorTypeCard() }}
                            </mat-error>
                            </mat-form-field>
                        </div>

                    <!-- card-name -->
                    <div class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <input  matInput placeholder="Nom sur la carte :" formControlName="name">
                            <mat-error *ngIf="!formGroup.controls['name'].valid || formGroup.controls['name'].touched">
                                {{ getErrorNameCard() }}
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <!-- expiration & code -->
                    <div class="row justify-content-center">
                        <mat-form-field class="col-5">
                            <input  matInput [textMask]="expiryMask" placeholder="Date d'expiration :"
                                formControlName="expiration">
                            <mat-error
                                *ngIf="!formGroup.controls['expiration'].valid || formGroup.controls['expiration'].touched">
                                {{ getErrorExpirationCard() }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="col-5">
                            <input   matInput placeholder="(CVC) :" formControlName="code">
                            <mat-error *ngIf="!formGroup.controls['code'].valid || formGroup.controls['code'].touched">
                                {{ getErrorCodeCard() }}
                            </mat-error>
                        </mat-form-field>
                    </div>








                </mat-card-content>
            </mat-card>



        </div>









        <!-------------------------------- bouton ----------------------------------->
        <div class="row justify-content-center mt-5">
            <button class="col-8 col-md-3 primary-bouton " mat-raised-button color="primary" (click)="sendCard()"
                type="submit">Pré-autorisation de 50 €</button>
        </div>

    </form>


</div>




<h2 *ngIf="!stationDetail" class="text-center">Veuillez  rescanner  le QR code</h2>


</div>